















import VueOptions from '@utils/VueOptions'
import LoadingIndicator from '@components/LoadingIndicator'
import Back from '@modules/ui/buttons/Back'
import EventFeed from '@ui/EventFeed/EventFeed'
import ShoppingCart from '@ui/EventFeed/ShoppingCart'

settings =
  name: "EventFeedShow"
  components: { LoadingIndicator, Back, EventFeed, ShoppingCart }
  resources:
    scanners:
      resourceName: 'scanners'
      slug: 'scanners'
  vue:
    methods:
      selectedScannerId: -> @scanners?[0]?.id

export default VueOptions.vue settings
